// Login page component

import Alpine from 'alpinejs';
import Swal from 'sweetalert2';
import { auth } from '../auth.js';

Alpine.data('loginPage', () => ({
  username: '',
  pin: '',
  isLoading: false,

  async init() {
    // Si ya hay sesión, redirigir al dashboard
    if (auth.isAuthenticated()) {
      window.location.hash = 'dashboard';
    }
  },

  async login() {
    if (!this.username || !this.pin) {
      Swal.fire('Error', 'Usuario y PIN son obligatorios', 'error');
      return;
    }

    this.isLoading = true;

    try {
      const success = await auth.login(this.username, this.pin);
      
      if (success) {
        Swal.fire({
          icon: 'success',
          title: '¡Bienvenido!',
          text: `Hola ${auth.getUser()?.displayName || this.username}`,
          timer: 1500,
          showConfirmButton: false
        });
        
        // Redirigir al dashboard
        setTimeout(() => {
          window.location.hash = 'dashboard';
        }, 1500);
      } else {
        Swal.fire('Error', 'Credenciales incorrectas', 'error');
        this.pin = '';
      }
    } catch (error) {
      console.error('Login error:', error);
      Swal.fire('Error', 'No se pudo conectar con el servidor. Intenta en modo offline.', 'error');
      this.pin = '';
    } finally {
      this.isLoading = false;
    }
  },

  onEnter(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.login();
    }
  }
}));

